import React from 'react';
import {View} from 'MWC';
import tpl from '../template/newInstallment';
import PropTypes from 'prop-types';
import Model from '../model/newInstallment.m';
import {apiback} from '../../../config';
import widgetsHelper from 'utils/getWidget.helper';

const newInstallmentPlan = 'new_installment_plan';
export default class extends View {
    templates = {
        [this.uiStates.INITIAL]: <div />,
        [this.uiStates.INTERACTIVE]: tpl,
        [this.uiStates.ERROR]: tpl,
        [this.uiStates.STANDBY]: tpl
    };

    constructor(props) {
        super(props);

        this.state = {
            ui: this.uiStates.INITIAL,
            selectedType: newInstallmentPlan,
            model: {},
            mode: 'info',
            where_by: ['path'],
            search_by: [location.pathname],
            widgets: []
        };

        this.crefs = {};
        this.widgetsHelper = widgetsHelper;

        return this;
    }

    toggleMode = mode => {
        this.setState({mode: mode});
    };

    componentWillMount() {
        fetch(apiback('NEW_INSTALLMENT'))
            .then(response => response.json())
            .then(json =>
                this.setState({
                    model: new Model(json.data[newInstallmentPlan], this.state.selectedType)
                })
            );
        // .catch(x => console.log('error:', x)); //todo добавить обработчик
    }

    componentWillReady() {
        this.widgetsHelper.getWidgets.call(this);
    }

    static displayName = 'Credit.Views.NewInstallment';

    static contextTypes = {
        app: PropTypes.object
    };
}
